import FirmwaresPage from './FirmwaresPage';

export default FirmwaresPage;
